<template>
  <div class="modal-content p-4">
    <div class="flex flex-col rounded-2xl border border-green-500 px-4 py-2 text-center bg-white">
      <span class="text-xl">
        {{ $t('bundler.last_chance_to_save') }}
      </span>
      <span class="tracking-tighter xs:tracking-normal">
        {{ $t('bundler.we_like_you_more') }}
      </span>
    </div>
    <div class="flex flex-col gap-4">
      <div class="bundle-callouts checkmark-callouts-dark flex flex-col gap-3 text-left text-sm sm:text-base">
        <CheckmarkCallout :text="$t(store.isCoffeeBundle ? 'bundler.free_coffee_spoon' : 'bundler.free_blenderbottle')" />
        <CheckmarkCallout :text="$t('bundler.savings_off_first_order', { firstSavings: store.pricing.firstSavings })" />
        <CheckmarkCallout :text="$t('bundler.savings_off_future_orders', { savings: store.pricing.savings })" />
        <CheckmarkCallout :text="$t('bundler.free_new_flavor_with_every_box')">
          <button
            v-if="!store.isCoffeeBundle"
            class="text-blue-500"
            @click="modalActive = true"
          >
            <svg-icon
              name="info"
              class="w-4 h-4 sm:hidden"
            />
            <span class="hidden sm:block">
              {{ $t('common.learn_more') }}
            </span>
          </button>
        </CheckmarkCallout>
        <CheckmarkCallout
          v-if="!store.isCoffeeBundle"
          :text="$t('bundler.subscribers_flavors')"
        />
      </div>
      <div class="flex flex-col gap-3">
        <DisclosureButton
          class="+green"
          data-gtm-category="bundle"
          data-gtm-action="checkout"
          data-gtm-label="subscription switch"
          :disabled="checkout.loading"
          :value="$cart.subscriptionTotalPrice"
          @click="checkout.addToCart('subscription')"
        >
          {{ $t('bundler.checkout_with_subscription') }}
        </DisclosureButton>
        <DisclosureButton
          class="+border"
          data-gtm-category="bundle"
          data-gtm-action="checkout"
          data-gtm-label="confirm one time"
          :disabled="checkout.loading"
          :value="$cart.onetimeTotalPrice"
          @click="checkout.addToCart()"
        >
          {{ $t('bundler.continue_with_onetime') }}
        </DisclosureButton>
      </div>
    </div>
    <CloseButton
      class="absolute top-1 right-1"
      @click="close"
    />
    <vue-modal
      v-model="modalActive"
      @close="modalActive = false"
    >
      <LearnMoreModal @close="modalActive = false" />
    </vue-modal>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'
import { useBundleCheckoutStore, useBundleStore } from '@/stores'
import { CheckmarkCallout } from '@oatsovernight/storybook'
import { CloseButton } from '@oatsovernight/storybook'
import DisclosureButton from './disclosure-button.vue'
import LearnMoreModal from './learn-more-modal.vue'
export interface Props {
  hideAddMore?: boolean
}
defineProps<Props>()
const emit = defineEmits([ 'close' ])
const store = useBundleStore()
const checkout = useBundleCheckoutStore()
const modalActive = ref(false)
const close = () => {
  store.onetimeConfirm = false
  emit('close')
}
onBeforeUnmount(() => store.onetimeConfirm = false)
</script>

<style>
@reference 'tailwindcss';
.bundle-callouts .checkmark-callout {
  @apply gap-2 pl-1;
}
</style>
